<template>
    <v-container fluid>
        <page-header title="Team Applications" icon="mdi-application-import">
            <table-filters :fields="filterFields" :value="filterValues" @apply="applyFilters" />
        </page-header>
        <array-view
            :items="teamApplications"
            :headers="displayInfo"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            :sort-by="sort.sortBy"
            :sort-desc="sort.sortDesc"
            :hide-actions="false"
            type="teamApplication"
            :delete-action="true"
            @paginationChange="paginationChange"
            @sortChange="changeSort"
            @onDelete="onDelete"
            @handleClick="handleClick"
        />
    </v-container>
</template>

<script>
    import teamApplicationService from '@/services/team-application'
    import ArrayView from '@/components/ArrayView'
    import TableFilters from '@/components/TableFilters'
    import PageHeader from '@/components/PageHeader'
    import listTable from '@/mixins/listTable'

    export default {
        name: 'Arena',
        components: { ArrayView, TableFilters, PageHeader },
        mixins: [listTable],
        data: () => {
            return {
                successfullImport: null,
                teamApplications: [],
                displayInfo: [
                    {
                        text: 'Id',
                        value: 'id'
                    },
                    {
                        text: 'Team Name',
                        value: 'teamName'
                    },
                    {
                        text: 'Status',
                        value: 'status'
                    }
                ],
                tableKey: 'teamApplications',
                filterFields: [
                    { key: 'teamName', label: 'Team Name', type: 'text' },
                    { key: 'telephone', label: 'Telephone', type: 'text' },
                    { key: 'status', label: 'Status', type: 'select', items: ['pending', 'accepted', 'rejected'], default: 'pending' }
                ],
                showImportDialog: false,
                size: 5,
                totalPages: 0,
                page: 1
            }
        },
        created() {
            this.fetchItems()
        },
        methods: {
            fetchItems() {
                teamApplicationService.getFilteredTeamApplications(this.filterQuery, this.page, this.size, this.sort).then(resp => {
                    this.teamApplications = resp.data.content
                    this.totalPages = resp.data.totalPages
                })
            },
            onDelete(application) {
                teamApplicationService.deleteTeamApplication(application.id).then(resp => {
                    this.$root.$emit('requests-changed')
                    this.fetchItems()
                })
            },
            handleClick(action, item) {
                this.$router.push(`/team-applications/${item.id}`)
            }
        }
    }
</script>

<style scoped>
.card-title {
    display: flex;
}

.v-list-item {
    min-height: 30px !important;
}

.v-card {
    min-width: 250px;
    position: relative;
}

.header-card {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1%;
}

.header-buttons {
    align-self: center;
}

.edit-button:hover {
    background-color: whitesmoke;
    color: white;
}

.screen-card {
    padding: 4%;
}

.overflow-text {
    max-width: 79%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.pagination {
    justify-content: center;
}
</style>
